import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import LottiePlayer from './LottiePlayer';

const TutorialSlide = ({ slide, onCta, isMobile }) => {
  const Icon = slide.icon;
  const visual = (
    <Box
      sx={{
        width: { xs: 160, sm: 200, md: 240 },
        height: { xs: 160, sm: 200, md: 240 },
        borderRadius: '50%',
        background: `radial-gradient(circle at 30% 30%, ${slide.color}22, ${slide.color}05 70%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {Icon && (
        <Icon sx={{ fontSize: { xs: 84, sm: 110, md: 130 }, color: slide.color }} />
      )}
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 3, md: 6 },
        textAlign: { xs: 'center', md: 'left' },
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 4 },
        minHeight: { xs: 380, md: 320 },
      }}
    >
      <LottiePlayer path={slide.lottiePath} fallback={visual} size={isMobile ? 200 : 260} />
      <Box sx={{ maxWidth: 460 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom sx={{ color: slide.color }}>
          {slide.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.65, mb: 2 }}>
          {slide.body}
        </Typography>
        {slide.ctaLabel && (slide.ctaPath || slide.actionKind) && (
          <Stack direction="row" justifyContent={{ xs: 'center', md: 'flex-start' }}>
            <Button
              variant={slide.actionKind === 'seedDemo' ? 'contained' : 'text'}
              onClick={() => onCta(slide)}
              sx={slide.actionKind === 'seedDemo'
                ? { backgroundColor: slide.color, color: '#fff', textTransform: 'none', fontWeight: 600, '&:hover': { backgroundColor: slide.color, opacity: 0.9 } }
                : { color: slide.color, textTransform: 'none', fontWeight: 600 }}
            >
              {slide.ctaLabel} {slide.actionKind === 'seedDemo' ? '✦' : '→'}
            </Button>
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default TutorialSlide;
